import { useEffect } from "react"
import { isRouteErrorResponse, Link, useRouteError, useLocation } from "react-router-dom"
import { captureException } from "@/lib/observability"

export function RouteErrorBoundary() {
  const error = useRouteError()
  const location = useLocation()

  let title = "Something went wrong"
  let message = "An unexpected error occurred."

  if (isRouteErrorResponse(error)) {
    title = `Error ${error.status}`
    message =
      typeof error.data === "string"
        ? error.data
        : error.statusText || "Request failed."
  } else if (error instanceof Error) {
    message = error.message
  }

  // Report error to observability
  useEffect(() => {
    if (error instanceof Error) {
      captureException(error, {
        route: location.pathname,
        component: "RouteErrorBoundary",
      })
    } else if (isRouteErrorResponse(error)) {
      captureException(new Error(`Route error: ${error.status} ${error.statusText}`), {
        route: location.pathname,
        status: error.status,
        statusText: error.statusText,
        component: "RouteErrorBoundary",
      })
    } else {
      captureException(new Error("Unknown route error"), {
        route: location.pathname,
        component: "RouteErrorBoundary",
        errorType: typeof error,
      })
    }
  }, [error, location.pathname])

  return (
    <div className="mx-auto max-w-2xl space-y-4 p-8">
      <h1 className="text-2xl font-bold">{title}</h1>
      <p className="text-muted-foreground">{message}</p>
      <div className="flex items-center gap-3">
        <Link className="text-sm font-medium underline" to="/companies/list">
          Go to Companies
        </Link>
        <button
          className="text-sm font-medium underline"
          onClick={() => window.location.reload()}
        >
          Reload
        </button>
      </div>
    </div>
  )
}
